import { render, staticRenderFns } from "./FreightEditor.vue?vue&type=template&id=6a0cc46e"
import script from "./FreightEditor.vue?vue&type=script&lang=js"
export * from "./FreightEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports